module.exports = __webpack_public_path__ + "static/media/drop-slide-thumb-5.bbc0b432.png";